import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
    src?: string;
    name?: string;
    className?: string;
    fallbackClassName?: string;
}

/**
 * Reusable UserAvatar component that handles fallback initials
 */
export function UserAvatar({ src, name, className, fallbackClassName }: UserAvatarProps) {
    const words = name ? name.split(" ").filter(Boolean) : [];
    const initials = words.length > 0
        ? (words.length > 1
            ? words[0][0] + words[words.length - 1][0]
            : words[0][0]
        ).toUpperCase()
        : "U";

    return (
        <Avatar className={className}>
            <AvatarImage src={src} alt={name} referrerPolicy="no-referrer" />
            <AvatarFallback className={fallbackClassName}>
                {initials}
            </AvatarFallback>
        </Avatar>
    );
}
